const siteReady = () => {
  $(window).scroll(() => stickyHeader())

  fixFooter()

  $(window).resize(() => fixFooter())

  if ($('.alert').length > 0) {
    hideUnwantedFlashMessages()
  }

  bootstrapFixes()
  setGrayLayoutBg()
  previewSchool()
  currentUserHasPermission()
}

;(window as any).closeAlertHeader = function () {
  $('.view-school').removeClass('alert-wrapper')
  return $('.alert-header').remove()
}

let previewSchool = function () {
  let selected_admin
  let selected_logged_in
  let selected_logged_out
  const current_url = location.origin + location.pathname

  if (
    siteGuard((window as any).currentUser(), (x) => x.preview) === 'logged_in'
  ) {
    selected_logged_in = 'class="bold"'
    selected_logged_out = ''
    selected_admin = ''
  } else if (
    siteGuard((window as any).currentUser(), (x1) => x1.preview) ===
    'logged_out'
  ) {
    selected_logged_in = ''
    selected_admin = ''
    selected_logged_out = 'class="bold"'
  } else if (
    siteGuard((window as any).currentUser(), (x2) => x2.preview) === 'admin'
  ) {
    selected_logged_in = ''
    selected_logged_out = ''
    selected_admin = 'class=bold'
  }

  const view_school_nav = `<li class="dropdown"> \
<a aria-expanded="false" aria-haspopup="true" class="fedora-navbar-link navbar-link dropdown-toggle" data-toggle="dropdown"> \
Preview as \
<i class="caret"></i> \
</a> \
<ul class="dropdown-menu"> \
<li> \
<a href="${current_url}?preview=admin" ${selected_admin} data-no-turbolink="true"> \
Admin user \
</a> \
</li> \
<li> \
<a href="${current_url}?preview=logged_in" ${selected_logged_in} data-no-turbolink="true"> \
Logged in user \
</a> \
</li> \
<li> \
<a href="${current_url}?preview=logged_out" ${selected_logged_out} data-no-turbolink="true"> \
Logged out user \
</a> \
</li> \
</ul> \
</li>`

  // If school has launched and admin is logged in, show them a switch mode toggle
  if (currentUserHasPermission()) {
    return $('.navbar-nav li.dropdown:first').before(() => view_school_nav)
  }

  return undefined
}

// Sticky header as you scroll
let stickyHeader = function () {
  if (
    ($(window) as any).scrollTop() + $(window).height() >
    450 + ($(window) as any).height()
  ) {
    $('header #navbar')
      .removeClass('is-at-top')
      .removeClass('is-above-the-fold')
      .addClass('is-scrolling')
  } else if (
    ($(window) as any).scrollTop() + $(window).height() >
    100 + ($(window) as any).height()
  ) {
    $('header #navbar')
      .removeClass('is-scrolling')
      .addClass('is-above-the-fold')
  } else {
    $('header #navbar')
      .addClass('is-at-top')
      .removeClass('is-above-the-fold')
      .removeClass('is-scrolling')
  }
}

// Dynamically add padding to body on page load & resize to match the footer height
let fixFooter = function () {
  $('body').css('padding-bottom', ($('footer') as any).outerHeight())
}

// Misc Bootstrap fixes
let bootstrapFixes = () =>
  $('.dropdown-menu').click((event) => {
    event.stopPropagation()
  })

let setGrayLayoutBg = function () {
  if (($('.gray-layout') as any).size() > 0) {
    const grayBg = $('.gray-layout').css('background-color')
    $('body').css('background-color', grayBg)
  }
}

// These unwanted flash messages appear from time to time on signup / login forms
let hideUnwantedFlashMessages = function () {
  $('.alert:contains(You have signed up successfully)').hide()
  $('.alert:contains(Signed in successfully)').hide()
  $('.alert:contains(You need to sign in or sign up before continuing.)').hide()
  $('.alert:contains(Please update your password)').hide()
  return $('.alert:contains(You are already signed in)').hide()
}

let currentUserHasPermission = function () {
  if (
    siteGuard((window as any).currentUser(), (x) => x.role) === 'owner' ||
    siteGuard((window as any).currentUser(), (x1) => x1.role) === 'author'
  ) {
    return true
  }
  if (
    siteGuard((window as any).currentUser(), (x2) => x2.role) === 'staff' ||
    siteGuard(
      (window as any).currentUser(),
      (x3) => x3.customRoleCoursePermissions
    ) === true
  ) {
    return true
  }
  return false
}

$(document).on('page:load ready', siteReady)

function siteGuard(value, transform) {
  return typeof value !== 'undefined' && value !== null
    ? transform(value)
    : undefined
}
